import type { Environment } from '../../../types/environment';
import type { ConnectionConfig } from '../../../types/types';

type ToolSavePayload = {
  enabled: boolean;
  mainConnectionId?: string | null;
  environment?: Environment;
};

type ConnectorState = Pick<ConnectionConfig, 'id' | 'isActive' | 'environment'>;

export function applyConnectorStateToToolSave<T extends ToolSavePayload>(
  tool: T,
  connectors: ConnectorState[]
): T & { enabled: boolean; environment: Environment } {
  const selectedConnector = connectors.find((connector) => connector.id === tool.mainConnectionId);
  const connectorIsActive = !!(selectedConnector && selectedConnector.isActive);

  return {
    ...tool,
    enabled: connectorIsActive ? tool.enabled : false,
    environment: selectedConnector?.environment || tool.environment || 'prod',
  };
}
